module.exports = __webpack_public_path__ + "static/media/arrow-up-square.3a355e79.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/arrow-up-square.svg
// module id = 270
// module chunks = 0